import { Component, Input, OnInit } from '@angular/core';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

export enum MessageType {
  NONE,
  SUCCESS,
  ERROR
}

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {

  MessageType = MessageType;

  @Input() type: MessageType = MessageType.NONE;
  @Input() message: string;
  @Input() id: string | number;

  faTimes = faTimes;
  faCheck = faCheck;

  constructor() {
  }

  ngOnInit(): void {
  }

}
